import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './copy-scenario.modal.scss';
import { IMAGES_REPO } from '../../../../static-resources/home-image-repo';

interface CopyScenarioModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  onCopy: (name: string) => void;
  isLoading?: boolean;
  defaultScenarioName?: string;
}

export const CopyScenarioModal = ({
  defaultScenarioName = '',
  show,
  setShow,
  onCopy,
  isLoading = false,
}: CopyScenarioModalProps) => {
  const [scenarioName, setScenarioName] = useState(defaultScenarioName);
  const [nameError, setNameError] = useState(false);
  useEffect(() => {
    setScenarioName(defaultScenarioName);
  }, [defaultScenarioName]);

  const handleClose = () => {
    //setScenarioName("");
    setNameError(false);
    setShow(false);
  };

  const handleCopy = () => {
    if (!scenarioName.trim()) {
      setNameError(true);
      return;
    }
    onCopy(scenarioName.trim());
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      className="copy-scenario-modal"
    >
      <Modal.Header closeButton>
        <div className="d-flex align-items-center gap-2">
          <img src={IMAGES_REPO.CopyIcon} alt="Copy" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="">
          <h2 className="header-title">Copy Scenario</h2>
          <p className="text-muted">Please enter a name for this scenario.</p>
        </div>
        <label htmlFor="scenarioName" className="form-label">
          Scenario name
        </label>
        <input
          id="scenarioName"
          type="text"
          className={`form-control ${nameError ? 'is-invalid' : ''}`}
          placeholder="e.g. Website design"
          max={256}
          min={5}
          value={scenarioName}
          onChange={(e) => {
            setScenarioName(e.target.value);
            if (nameError && e.target.value.trim()) setNameError(false);
          }}
          disabled={isLoading}
        />
        {nameError && (
          <div className="invalid-feedback">Scenario Name is required.</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-danger"
          onClick={handleClose}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button variant="primary" onClick={handleCopy} disabled={isLoading}>
          {isLoading ? <>Copying...</> : 'Copy and Open'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CopyScenarioModal;
